import React from 'react'
import ProjectStep from "../components/ProjectStep";

export default class BudgetStep extends ProjectStep {

    static TranslationKey = 'budget_step';

    static path = '/budget';
    static slug = 'budget';
    static Optional = true;

    static ValidationMethodName = 'validateBudget';

    static StepName = 'Budget Range'

    static hasCompleted(project) {
        return project.validateBudget();
    }


    /**
     * @param {Project} project
     * @returns {Object}
     */
    static reviewMapping(project) {
        return {
            ['Client Provided Budget']: project.hasBudget() ? project.budgetRange() : <span className="text-muted">Not Set</span>
        }
    }

    async onChange(params) {
        let {
            max_budget,
            min_budget
        } = params;

        if (!TB.isNaN(parseInt(max_budget))) {
            max_budget = parseInt(max_budget)
        }
        if (!TB.isNaN(parseInt(min_budget))) {
            min_budget = parseInt(min_budget)
        }
        super.onChange({
            max_budget,
            min_budget
        });
    }

    /**
     * The fields mapping for the form
     */
    formFields = () => {
        let {
            min_budget
        } = this.props.project;

        if (TB.isNumber(min_budget)) min_budget = parseInt(min_budget);

        let requiredMax =  TB.trans('validation.required', {
            'attribute':  this.translate('budget_step_label') + " " + this.translate('max_budget_label'),
        }), requiredMin =  TB.trans('validation.required', {
            'attribute':  this.translate('budget_step_label') + " " + this.translate('min_budget_label'),
        });
        return [
            {
                header: this.translate('budget_step_label'),
                fields: {
                    budget_question: (
                        <p className="create-project-form-field-question">
                            {this.translate('budget_question')}
                        </p>
                    ),
                    budgets: {
                        fields: {
                            min_budget: {
                                label: this.translate('min_budget_label'),
                                type: 'number',
                                addonBefore: "$",
                                required: false,
                                validation: {
                                    rules: {
                                        minBudgetValidation: function (model, value) {
                                            let min = parseInt(value);
                                            if(TB.isNumber(min) && min < 500) {
                                                return "The minimum budget for a project starts at $500";
                                            }else if(TB.isNumber(min) && min > 10000000) {
                                                return "The minimum budget cannot be greater than $10,000,000";
                                            }
                                            return true
                                        },
                                        isInt: true
                                    }
                                },
                                validationErrors: {
                                    isDefaultRequiredValue: requiredMin
                                }
                            },
                            max_budget: {
                                label: this.translate('max_budget_label'),
                                type: 'number',
                                required: false,
                                addonBefore: "$",
                                validation: {
                                    rules: {
                                        maxBudgetValidation: function (model, value) {
                                            let max = parseInt(value);
                                            if(TB.isNumber(max) && TB.isNumber(min_budget) && max < min_budget) {
                                                return "The maximum budget must be greater than the minimum";
                                            }else if(TB.isNumber(max) && max > 10000000) {
                                                return "The maximum budget cannot be greater than $10,000,000";
                                            }

                                            return true
                                        },
                                        isInt: true
                                    }
                                },
                                validationErrors: {
                                    isDefaultRequiredValue: requiredMax,
                                }
                            },
                        }
                    }
                }
            },
        ]
    };
}
